import React from "react";

interface ICheckInOutTimelineProps {
  checkIn?: string | null;
  checkOut?: string | null;
}

// Listings store times as typed by Laravel, e.g. "02:00 p.m."; show them as "2:00 PM".
const formatListingTime = (value?: string | null): string | null => {
  const raw = value?.trim();
  if (!raw) return null;
  return raw
    .replace(/\s*([ap])\.?\s*m\.?$/i, (_, p: string) => ` ${p.toUpperCase()}M`)
    .replace(/^0(\d:)/, "$1");
};

const CheckInOutTimeline: React.FC<ICheckInOutTimelineProps> = ({
  checkIn,
  checkOut,
}) => {
  const inTime = formatListingTime(checkIn);
  const outTime = formatListingTime(checkOut);
  if (!inTime && !outTime) return null;

  const rows = [
    inTime && { label: "Check In", value: `After ${inTime}`, filled: true },
    outTime && {
      label: "Check Out",
      value: `Before ${outTime}`,
      filled: false,
    },
  ].filter(Boolean) as { label: string; value: string; filled: boolean }[];

  return (
    <ol className="relative">
      {rows.map((row, i) => (
        <li key={row.label} className="relative flex gap-4 pb-6 last:pb-0">
          {i < rows.length - 1 && (
            <span
              aria-hidden
              className="absolute left-[5px] top-4 bottom-1 w-px bg-neutral-300"
            />
          )}
          <span
            aria-hidden
            className={`relative mt-1.5 h-[11px] w-[11px] flex-shrink-0 rounded-full border-2 border-neutral-900 ${
              row.filled ? "bg-neutral-900" : "bg-white"
            }`}
          />
          <div>
            <p className="text-sm text-ink-gray">{row.label}</p>
            <p className="mt-0.5 text-base font-medium text-ink-black">
              {row.value}
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
};

export default CheckInOutTimeline;
